import { briefGroups } from "@/mocks/homeContent";

const groups = ["刚刚", "今天", "昨日"];

export default function BriefFeed() {
  return (
    <section id="briefs" className="border-y border-secondary-200/70 bg-background-100/50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
            <i className="ri-chat-smile-3-fill text-lg leading-none"></i>
          </span>
          <div>
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              短讯速览
            </h2>
            <p className="text-xs text-foreground-500">三言两语，快速跟上当下正在发生的事。</p>
          </div>
        </div>

        {/* 时间线 */}
        <div className="relative mt-8">
          <span className="absolute bottom-4 left-[5px] top-4 w-px bg-secondary-200"></span>
          {groups.map((g) => {
            const items = briefGroups.filter((b) => b.group === g);
            return (
              <div key={g} className="relative mb-7 pl-7 last:mb-0">
                {/* 分组原点 */}
                <span
                  className={`absolute left-0 top-1.5 h-2.5 w-2.5 rounded-full ${
                    g === "刚刚" ? "bg-primary-500" : g === "今天" ? "bg-accent-500" : "bg-secondary-300"
                  }`}
                ></span>
                <div className="mb-3 flex items-center gap-2">
                  <span className="rounded-full bg-background-50 px-2.5 py-0.5 text-xs font-semibold text-secondary-700 ring-1 ring-secondary-200">
                    {g}
                  </span>
                  <span className="text-[11px] text-foreground-400">{items.length} 条</span>
                </div>

                <ul className="space-y-2">
                  {items.map((b) => (
                    <li key={b.id}>
                      <button className="group flex w-full items-start gap-3 rounded-xl border border-secondary-200/60 bg-background-50 px-4 py-3 text-left transition-colors hover:border-primary-300">
                        <span className="mt-0.5 shrink-0 font-display text-sm text-secondary-400">{b.time}</span>
                        <span className="min-w-0 flex-1">
                          <span className="block truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
                            {b.title}
                          </span>
                          <span className="mt-0.5 block line-clamp-2 text-xs leading-5 text-foreground-500">
                            {b.summary}
                          </span>
                        </span>
                        <span className="mt-0.5 shrink-0 rounded bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                          {b.tag}
                        </span>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="mt-2 flex justify-center">
          <button className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-secondary-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700">
            <i className="ri-refresh-line text-base leading-none"></i>
            加载更早速览
          </button>
        </div>
      </div>
    </section>
  );
}